import { render } from "./tags-nav.vue?vue&type=template&id=cccc1bba"
import script from "./tags-nav.vue?vue&type=script&lang=js"
export * from "./tags-nav.vue?vue&type=script&lang=js"

import "./tags-nav.vue?vue&type=style&index=0&id=cccc1bba&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__